<script lang="ts" setup>
import PrimeButton from '@/components/UI/PrimeButton.vue';
import PrimeLoader from '@/components/UI/PrimeLoader.vue';
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useSurveyStore } from '@/stores/survey';

const surveyStore = useSurveyStore();
const { loading, valid, currentStep, totalSteps } = storeToRefs(surveyStore);

const timer = ref(0);
const interval = ref<any>(null);

const startTimer = () => {
	interval.value = setInterval((): void => {
		timer.value++;
	}, 1000);
};

onMounted(() => {
	startTimer();
});

const nextStep = (): void => {
	if (!valid.value) return;

	surveyStore.setCurrentQuestion({ delay_time: timer.value });
	surveyStore.setAnswers();

	timer.value = 0;
	clearInterval(interval.value);

	if (currentStep.value !== totalSteps.value) {
		surveyStore.setNextStep();

		startTimer();
		return;
	}

	surveyStore.sendAnswers();
};

defineEmits<{
	(e: 'click'): void;
}>();
</script>

<template>
	<div class="actions container">
		<PrimeButton
			v-if="currentStep !== totalSteps"
			data-test-id="step-button-next"
			class="button--full"
			:disabled="!valid"
			@click="nextStep"
		>
			{{ $t('next') }}
		</PrimeButton>
		<PrimeButton
			v-else
			class="button--full"
			:class="{ 'button--icon-right': loading }"
			:disabled="loading || !valid"
			data-test-id="step-button-complete"
			@click="nextStep"
		>
			{{ $t('complete') }}
			<PrimeLoader v-if="loading" color="white" size="16" />
		</PrimeButton>
	</div>
</template>

<style lang="scss">
.actions {
	padding-top: 1.25rem;
	padding-bottom: 1.25rem;
	text-align: center;

	.button {
		max-width: 400px;
	}
}
</style>
